import React, { useState } from 'react';
import { DEFAULT_H3_CONFIG, getH3StatusLabel } from './h3SpatialUtils';

const H3SpatialIndexControl = () => {
  const [config, setConfig] = useState(DEFAULT_H3_CONFIG);

  const toggleH3 = () => {
    setConfig((current) => ({
      ...current,
      enabled: !current.enabled,
      status: !current.enabled ? 'active' : 'disabled',
    }));
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen dark:bg-gray-900">
      <div className="max-w-5xl mx-auto space-y-6">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-600 dark:text-blue-400">
                Spatial indexing
              </p>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white mt-2">
                H3 Hexagon Control Panel
              </h1>
            </div>

            <button
              type="button"
              onClick={toggleH3}
              className={`inline-flex items-center justify-center px-5 py-3 rounded-xl font-semibold transition-all ${
                config.enabled
                  ? 'bg-green-600 text-white hover:bg-green-700'
                  : 'bg-gray-300 text-gray-800 hover:bg-gray-400 dark:bg-gray-700 dark:text-gray-100'
              }`}
            >
              {config.enabled ? 'Disable H3' : 'Enable H3'}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5">
            <p className="text-sm text-gray-500 dark:text-gray-400">Status</p>
            <p className="mt-2 text-2xl font-bold text-gray-900 dark:text-white">{getH3StatusLabel(config)}</p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5">
            <p className="text-sm text-gray-500 dark:text-gray-400">Resolution</p>
            <p className="mt-2 text-2xl font-bold text-gray-900 dark:text-white">{config.resolution}</p>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5">
            <p className="text-sm text-gray-500 dark:text-gray-400">Fallback mode</p>
            <p className="mt-2 text-2xl font-bold text-gray-900 dark:text-white">
              {config.fallbackToLatLon ? 'Lat/Lon + text' : 'Text only'}
            </p>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Operational rules</h2>
          <ul className="mt-4 space-y-3 text-gray-700 dark:text-gray-300 list-disc list-inside">
            <li>Latitude/longitude remains the source of truth.</li>
            <li>H3 values are optional and derived when available.</li>
            <li>When H3 is off or fails, reports fall back to location text and lat/lon based grouping.</li>
            <li>The spatial layer can be toggled without interrupting trip creation or dispatch.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default H3SpatialIndexControl;
